import type { ComponentsArticleTimeline } from 'queries/graphql';

import StyledDiv from 'generic/StyledDiv';

import { buildCssVar } from 'utils/style-override';

import { TimelineCardMobile } from './components/Mobile';
import { TimelineCardDesktop } from './components/Desktop';

import styles from './styles.module.sass';

import dynamic from 'next/dynamic';

const MediaQuery = dynamic(() => import('react-responsive'), {
  ssr: false,
});

export default function Timeline({
  sectionId,
  title,
  backgroundColor,
  items = [],
}: ComponentsArticleTimeline) {
  return (
    <StyledDiv
      id={sectionId}
      className={`root ${styles.timeline}`}
      backgroundColor={backgroundColor}
    >
      <style jsx>{`
        .root {
          ${buildCssVar('--background-color', backgroundColor, 'var(--text-color-grey-dark)')}
        }
      `}</style>
      <div className={styles.container}>
        <div className={styles.column}>
          <h2 className={styles.title}>{title}</h2>

          {items?.map(item => (
            <>
              <MediaQuery maxWidth={980}>
                <TimelineCardMobile key={item.id} {...item} />
              </MediaQuery>
              <MediaQuery minWidth={981}>
                <TimelineCardDesktop key={item.id} {...item} />
              </MediaQuery>
            </>
          ))}
        </div>
      </div>
    </StyledDiv>
  );
}
